
import React from 'react';
import TabItem from '../UI/TabItem';

const ThirdSection = (props) => {
    
    const displayPopupOnClick = () =>{
        console.log("clickImage in  FirstSection:::");
        props.onClick();
        // setModalIsOpen(true);
    }

    const categoryHasId = (value) =>{
        return  value.toLowerCase().replace(/\s+/g, "-");
    }
    
    return (
        <>
            {(props.item.category3[0] && props.item.category3[0].title) && 
            <h3 id={categoryHasId(props.item.category3[0].title)}> {props.item.category3[0].title} </h3>}
            {(props.item.category3[0] && props.item.category3[0].tabpanel && props.item.category3[0].tab) && <TabItem tabPanels={props.item.category3[0].tabpanel} tabs={props.item.category3[0].tab} onClick = {displayPopupOnClick}/>} 

        </>
    )
}

export default ThirdSection;
